<template>
  <div :class="$style.wrap">
    <img :src="`${this.$cdnLink}/suspend/tongyong/guanbi.png`" alt="" @click="close" :class="$style.close" />
    <div :class="$style.active" v-if="taskInitList.length">
      <div :class="$style.currentDayActive">
        <img :src="`${$cdnLink}/kuaishou/banner1.png?v=1`" :class="$style.banner" />
        <div :class="$style.content">
          <h1>
            <span>{{ currentDay === realDay ? '今日活动' : '当日活动' }}</span>
            <div :class="$style.refresh" @click="refresh" v-if="currentDay === realDay">
              <i class="iconfont yw-shuaxin1"></i>
              <span>刷新</span>
            </div>
            <!-- <div :class="$style.abort">
              <img :src="`${$cdnLink}/kuaishou/jieshu.png`" alt="">
              <span>活动截止至2022年1月17日</span>
            </div> -->
          </h1>
          <img :src="`${$cdnLink}/kuaishou/rule.png`" :class="$style.rule" @click="showRule" />
          <div :class="[$style.main, currentDay !== realDay ? $style.gray : '']">
            <div>
              <div v-if="task.task_status != 2" :class="$style.state">
                <img :src="`${$cdnLink}/kuaishou/hint.png`" />
                <span>{{ task.task_title }}</span>
              </div>
              <div v-if="showOfficialReward && task.task_status == 2" :class="$style.state">
                <img :src="`${$cdnLink}/kuaishou/success.png`" />
                <div>
                  <span>今日任务已完成，<span v-if="code">您的道具码为：{{ code }}</span></span>
                  <p>奖励将下发至微信公众号【{{ officialAccount }}】，请及时前往，并在底部菜单栏“福利礼包”处进行“游戏账号绑定”，领取今日红包哦</p>
                </div>
              </div>
              <div v-if="!showOfficialReward && task.task_status == 2" :class="$style.state">
                <img :src="`${$cdnLink}/kuaishou/success.png`" />
                <div>
                  <span>今日任务已完成<span v-if="code">您的道具码为：{{ code }}</span></span>
                </div>
              </div>
            </div>
            <div :class="$style.officialAccount" v-if="showOfficialReward">
              <img :src="`${$cdnLink}/kuaishou/redPack.png`" alt />
              <span>关注‘{{ officialAccount }}’公众号，绑定游戏账户，即可领取红包奖励。</span>
            </div>
            <ul :class="$style.child_task">
              <li v-for="(item, index) in child_task" :key="index">
                <img :src="handleIcon(item.task_type)" alt />
                <div>
                  <p :class="$style.type">
                    <span>{{ handleTagText(item.task_type) }}</span>
                    <span v-if="index === 0 && currentDay === 1">新人专享</span>
                  </p>
                  <p :class="$style.subTitle">{{ item.task_title }}</p>
                  <p :class="$style.desc">{{ item.task_sub_title }}</p>
                </div>
                <button v-if="item.task_status == 2" :class="$style.forbidden">已完成</button>
                <button v-else-if="item.task_status == 3" :class="$style.forbidden">已发放</button>
                <button v-else-if="item.task_status == 4" :class="$style.forbidden">已过期</button>
                <button v-else-if="item.task_type == 4" @click="doKsTask(item)">去完成</button>
                <button v-else @click="doKsTask(item)">{{ item.task_btn_des }}</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <ul :class="$style.days">
        <li :class="$style.dayItem" v-for="item in days" :key="item" @click="setCurrentTask(item)">
          <span v-if="currentDay !== item">{{ `第${item}天` }}</span>
          <span v-else :class="$style.active">{{ `第${item}天` }}</span>
        </li>
      </ul>
    </div>
    <div :class="$style.ruleScreen" v-if="ruleScreenShow">
      <div :class="$style.bg">
        <h1>活动规则</h1>
        <img :src="`${$cdnLink}/kuaishou/close.png`" alt :class="$style.close" @click="ruleScreenShow = false" />
        <div :class="$style.content">
          <p :class="$style.title">活动规则</p>
          <p>
            1.
            <span>活动持续开展</span>，签到奖励领不停， <span>每日任务仅当天有效</span>。
          </p>
          <p>2. 活动期间，每日登录游戏后，完成当天指定任务即可领取签到奖励。</p>
          <p>3.<span>第一天的任务必须完成，只有完成第一天的任务后才能参与后续天的任务。</span></p>
          <p>
            4.
            <span>一个实名制微信号只可参与一次活动。</span>
          </p>
          <p>
            5.
            <span>请先前往微信公众号“{{ officialAccount }}”，底部菜单栏-福利礼包-游戏账号绑定处进行游戏账号的绑定</span
            >，绑定成功后，红包奖励自动发放至微信零钱处。
            <span>未及时绑定游戏账号将会影响当天的红包提现</span>，领取到道具的玩家可前往“背包”进行查看。
          </p>
          <p>6. 领取到道具的玩家复制礼包码，可前往游戏内进行兑换。</p>
          <p :class="$style.title" style="margin-top: 10px">注意事项</p>
          <p>
            1. 若在活动过程中遇到任何问题，请联系
            <span>官方客服</span>（左侧菜单栏客服入口）
          </p>
          <p>
            2. 红包奖励由系统审核，审核通过后将在
            <span>三小时内</span>进行发放。
          </p>
          <p>3. 若因系统特殊原因未收到红包，请联系<span>官方客服</span>，系统核实后将进行补发。</p>
          <p>4. 玩家领取道具请及时使用，避免逾期无法使用。</p>
        </div>
      </div>
    </div>
    <div :class="$style.completeScreen" v-if="completeScreenShow && completeScreenType">
      <div :class="$style.bg" v-if="completeScreenType === 1">
        <p :class="$style.title">活动不停歇，好礼领不停</p>
        <p :class="$style.content">今日任务已完成</p>
        <p :class="$style.desc">
          前往微信公众号
          <span>“{{ officialAccount }}”</span>领取红包奖励吧
        </p>
        <img :src="`${$cdnLink}/kuaishou/complete.png`" />
        <p :class="$style.hint">关注“{{ officialAccount }}”公众号，绑定游戏账号</p>
        <p :class="$style.hint">红包奖励即可下发至公众号。</p>
        <button class="btn" data-clipboard-text="btmao888" @click="completeScreenShow = false">一键复制微信公众号</button>
      </div>
      <div :class="[$style.bg, $style.scene]" v-if="completeScreenType === 3">
        <p :class="$style.title">活动不停歇，好礼领不停</p>
        <p :class="$style.content">今日任务已完成</p>
        <p :class="$style.desc">
          兑换码：
          <span>{{ code }}</span
          >，请及时兑换,
        </p>
        <p :class="$style.desc">避免逾期失效，无法兑换</p>
        <img :src="`${$cdnLink}/kuaishou/complete3.png`" />
        <button class="btn" :data-clipboard-text="code" @click="completeScreenShow = false">一键复制礼包码</button>
      </div>
      <div :class="[$style.bg, $style.scene]" v-if="completeScreenType === 4">
        <p :class="$style.title">活动不停歇，好礼领不停</p>
        <p :class="$style.content">今日任务已完成</p>
        <div :class="$style.card">
          <div :class="$style.sceneItem">
            <div>
              <p>
                您的兑换码为<span>“{{ code }}”</span>，请及时兑换避免逾期失效，无法兑换
              </p>
            </div>
            <button class="btn" :data-clipboard-text="code" @click="completeScreenShow = false">一键复制礼包码</button>
          </div>
          <div :class="$style.redPacketItem">
            <div>
              <p>
                前往微信公众号<span>“{{ officialAccount }}”</span>领取红包奖励吧
              </p>
            </div>
            <button class="btn" :data-clipboard-text="code" @click="completeScreenShow = false">一键复制微信公众号</button>
          </div>
        </div>
        <p :class="$style.hint">关注“{{officialAccount}}公众号，绑定游戏账号</p>
        <p :class="$style.hint">红包奖励即可下发至公众号</p>
      </div>
    </div>
    <div :class="$style.actFinish" v-if="!taskInitList.length && taskInitState">
      <img :src="`${$cdnLink}/kuaishou/task5.png`" />
      <p>活动正在加载中</p>
      <p :class="$style.hint">请耐心等待</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import {
  reportTaskShow,
  doKsTask as notifyDoKsTask,
  doKsTaskListener,
  onTaskErrorListener,
  getKsTaskList,
  onRequestRewardSuccess,
  ksTaskOnResume,
} from '@/bridge/AppJsBridge';
import { taskReport, taskConfirm } from '@/api/ks';
import { eventTrack } from '@/api/user';
import Clipboard from 'clipboard';

export default {
  name: '',
  props: ['realDay'],
  data() {
    return {
      days: 0,
      currentDay: 1, // 当前选择第几天
      taskNum: 1, // 当天任务数量
      hasComplete: false,
      task_id: '',
      task: {},
      child_task: [],
      ruleScreenShow: false,
      completeScreenShow: false,
      showOfficialReward: false,
      completeScreenType: '',
      code: '',
      wxBindState: null,
      officialAccount: '变态猫推荐',
    };
  },
  mounted() {
    this.currentDay = this.realDay;
    if (this.taskInitList.length) {
      this.setCurrentTask(this.currentDay);
    }
    this.buryReport('KS_FLOATING_BALL');
    this.copyInit();
    setTimeout(() => {
      this._listener();
    }, 200);
  },
  computed: {
    ...mapState({
      taskInitList: (state) => state.ks.taskInitList,
      taskInitState: (state) => state.ks.taskInitState,
      user_id: (state) => state.user.user_id,
      appkey: (state) => state.user.appkey,
      access_token: (state) => state.user.access_token,
      userState: (state) => state.user,
      completeScreenFlag: (state) => state.ks.completeScreenFlag,
    }),
  },
  watch: {
    taskInitList(val) {
      if (val.length) {
        this.setCurrentTask();
      }
    },
  },
  methods: {
    ...mapMutations({
      changeState: 'ks/CHANGE_STATE',
    }),
    copyInit() {
      this.clipboard = new Clipboard('.btn');
      this.clipboard.on('success', () => {
        this.$toast({
          message: '复制成功',
          position: 'bottom',
        });
      });
    },
    refresh() {
      getKsTaskList((data) => {
        this.changeState({ taskInitList: JSON.parse(data) });
      });
    },
    close() {
      this.$emit('close');
    },
    showRule() {
      this.ruleScreenShow = true;
      this.buryReport('KS_RULE_DETAIL');
    },
    buryReport(event) {
      const { device_info } = this.userState;
      eventTrack({
        appkey: this.appkey,
        event: event,
        device_id: device_info.device_id,
        os: device_info.os,
        user_id: this.user_id,
      });
    },
    _listener() {
      doKsTaskListener((data, cb) => {
        const _data = JSON.parse(data);
        console.log('----- 当前任务状态 ------', data);
        if ([1, 2, 4, 13].includes(_data.resultType)) {
          getKsTaskList((data) => {
            this.changeState({ taskInitList: JSON.parse(data) });
          });
        }
        if (_data.resultType == 11 && _data.sourceType == 1) this.$toast('当前任务尚未开始');
        if (_data.resultType == 12 && _data.sourceType == 1) this.$toast('正在执行任务');
        if (_data.resultType == 9 && _data.sourceType == 1) {
          this.$toast('正在下载中', 3000);
        }
      });
      onTaskErrorListener((data, cb) => {
        const _data = JSON.parse(data);
        if (_data.msg) this.$toast(_data.msg);
      });
      ksTaskOnResume((data, cb) => {
        getKsTaskList((data) => {
          this.changeState({ taskInitList: JSON.parse(data) });
        });
      });
    },
    // 首次进入和用户切换时候会传day
    setCurrentTask(day) {
      if (day) this.currentDay = day;
      const currentTask = this.taskInitList[this.currentDay - 1];
      this.task_id = currentTask ? currentTask.task_id : '';
      this.task = currentTask;
      const rewardList = this.task.rewards.filter(item => item.reward_type == 1);
      this.showOfficialReward = rewardList.length > 0;
      this.child_task = currentTask ? currentTask.child_task : '';
      this.days = this.taskInitList.length;
      if (currentTask) {
        this.report(currentTask); // 上报服务端
        reportTaskShow({ taskId: this.task_id }); // 上报快手
      }
      if (day) {
        this.buryReport(`KS_ACTIVITY_${this.currentDay}`);
      }
      if (this.task.task_status == 2 && !this.completeScreenFlag && this.currentDay == this.realDay) {
        this.completeScreenShow = true;
        this.$store.commit('ks/CHANGE_STATE', { completeScreenFlag: true });
      }
    },
    handleIcon(type) {
      switch (type) {
        case 1:
          return `${this.$cdnLink}/kuaishou/task1.png`;
        case 2:
          return `${this.$cdnLink}/kuaishou/task2.png`;
        case 3:
          return `${this.$cdnLink}/kuaishou/task3.png`;
        case 4:
          return `${this.$cdnLink}/kuaishou/task4.png`;
      }
    },
    handleTagText(type) {
      switch (type) {
        case 1:
        case 2:
          return '活动任务';
        case 3:
          return '充值任务';
        case 4:
          return '等级任务';
      }
    },
    async report(task, confirm) {
      const r = await taskReport({
        user_id: this.user_id,
        appkey: this.appkey,
        access_token: this.access_token,
        task_info: task,
      });
      this.wxBindState = r.content.wechat_status;
      this.completeScreenType = r.content.reward.type || 1;
      this.code = r.content.reward.code;
      if (r.content.code === 3) {
        onRequestRewardSuccess(task.task_id);
      } else if (!confirm) {
        this.confirm(task);
      }
    },
    async confirm(task) {
      const confirmResult = await taskConfirm({
        user_id: this.user_id,
        appkey: this.appkey,
        access_token: this.access_token,
        task_id: task.task_id
      });
      if (confirmResult.content.confirm_status === 1) {
        this.report(task, true);
      }
    },
    // 执行任务
    doKsTask(child_task) {
      notifyDoKsTask({
        taskId: this.task_id,
        subTaskId: child_task.task_id,
      });
    },
  },
  beforeDestroy() {
    this.clipboard && this.clipboard.destroy();
  },
};
</script>

<style lang="scss" module>
.wrap {
  width: 100%;
  height: 100%;
  background: #ffffff;
  > .close {
    position: absolute;
    top: 0;
    right: 0;
    width: 10px;
    height: 10px;
    z-index: 10;
    padding: 2px 7px;
    box-sizing: content-box;
  }
}
.active {
  background: #f6f6f6;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  position: relative;
  .currentDayActive {
    height: 350px;
    overflow-y: auto;
    padding: 13px 12px;
    .banner {
      width: 100%;
      display: inline-block;
    }
    > .content {
      position: relative;
      > h1 {
        display: flex;
        align-items: center;
        font-size: 13px;
        margin: 9px 0;
        .refresh {
          display: inline-block;
          background: linear-gradient(135deg, #ff7f7c, #ff5752);
          border-radius: 11px;
          font-size: 9px;
          color: #ffffff;
          padding: 4px 10px;
          margin-left: 5px;
          &:active {
            opacity: 0.8;
          }
          :global {
            .yw-shuaxin1 {
              font-size: 9px;
              color: #ffffff;
            }
          }
        }
        .abort {
          display: flex;
          align-items: center;
          color: #ff5752;
          font-size: 11px;
          margin-left: 5px;
          > img {
            width: 11px;
            height: 11px;
            margin-right: 3px;
          }
        }
      }
      .rule {
        position: absolute;
        top: 10px;
        right: 0;
        width: 37px;
        z-index: 1;
      }
      .main {
        background: #ffffff;
        padding: 13px 10px;
        border-radius: 5px;
        &.gray {
          filter: grayscale(100%);
          filter: gray;
          filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
        }
        .state {
          display: flex;
          img {
            width: 10px;
            height: 10px;
            display: inline-block;
            margin-right: 3px;
          }
          span {
            font-size: 10px;
            font-weight: bold;
          }
          p {
            color: #666666;
            font-size: 10px;
            margin-top: 3px;
          }
        }
        .officialAccount {
          position: relative;
          border-radius: 17px;
          background: #ececec;
          color: #666666;
          margin: 10px 0;
          padding: 5px 5px 5px 30px;
          line-height: 10px;
          font-size: 8px;
          > img {
            position: absolute;
            width: 34px;
            top: 50%;
            left: -5px;
            transform: translateY(-14px);
          }
        }
        .child_task {
          > li {
            display: flex;
            position: relative;
            padding-bottom: 7px;
            border-bottom: 1px solid #ebebeb;
            margin-bottom: 10px;
            img {
              width: 34px;
              height: 34px;
              margin-right: 9px;
            }
            .type {
              > span {
                background-color: #fcab02;
                color: #ffffff;
                font-size: 7px;
                padding: 3px 5px;
                display: inline-block;
                margin-bottom: 3px;
                border-radius: 2px;
              }
              span:nth-child(2) {
                background: #4abd7a;
                margin-left: 4px;
              }
            }
            .subTitle {
              color: #000000;
              font-size: 10px;
              margin-bottom: 2px;
            }
            .desc {
              color: #666666;
              font-size: 9px;
            }
            > button {
              position: absolute;
              right: 10px;
              // height: 21px;
              padding: 10px 10px;
              border: none;
              outline: none;
              color: #ffffff;
              background: linear-gradient(135deg, #ff7f7c, #ff5752);
              border-radius: 11px;
              font-size: 9px;
              line-height: 0;
              &.forbidden {
                opacity: 0.4;
              }
            }
          }
        }
      }
    }
  }
  .days {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #ffffff;
    height: 36px;
    font-size: 9px;
    color: #959595;
    display: flex;
    justify-content: space-around;
    box-shadow: 0 -20px 20px rgb(214, 214, 214);
    .dayItem {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      .active {
        display: inline-block;
        width: 50px;
        text-align: center;
        background: #ffffff;
        height: 50px;
        line-height: 50px;
        border-radius: 50%;
        color: #ff5955;
        font-size: 10px;
        margin-top: -14px;
      }
    }
  }
}
.ruleScreen {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10;
  line-height: 1.3;
  .bg {
    position: absolute;
    top: 20px;
    left: 0;
    right: 0;
    margin: auto;
    width: 288px;
    height: 335px;
    background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/kuaishou/bg.png?v=2') no-repeat;
    background-size: 100% 100%;
    > h1 {
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #ffffff;
      font-size: 16px;
    }
    .close {
      width: 11px;
      height: 11px;
      position: absolute;
      right: 15px;
      top: 22px;
    }
    .content {
      padding: 5px 20px;
      height: 270px;
      overflow: auto;
      .title {
        font-size: 10px;
        color: #000000;
        font-weight: bold;
        position: relative;
        line-height: 12px;
        padding-left: 5px;
        margin-bottom: 10px;
        &:after {
          position: absolute;
          content: ' ';
          left: 0;
          width: 2px;
          height: 12px;
          background: #ff5955;
          border-radius: 1px;
        }
      }
      > p {
        font-size: 10px;
        color: #666666;
        > span {
          color: #000000;
          font-weight: bold;
        }
      }
    }
  }
}
.completeScreen {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10;
  .bg {
    position: absolute;
    top: 40px;
    left: 0;
    right: 0;
    margin: auto;
    width: 250px;
    height: 229px;
    background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/kuaishou/bg1.png?v=2') no-repeat;
    background-size: 100% 100%;
    text-align: center;
    padding-top: 13px;
    .title {
      font-size: 14px;
      font-weight: bold;
      color: #ffffff;
      line-height: 17px;
      text-shadow: 0px 0px 2px #ff5752;
      margin-bottom: 20px;
    }
    .content {
      font-size: 14px;
      font-weight: bold;
      color: #ff6e6e;
      line-height: 20px;
    }
    .desc {
      font-size: 9px;
      font-weight: bold;
      color: #000000;
      line-height: 14px;
      margin-bottom: 7px;
      > span {
        color: #ff6e6e;
      }
    }
    > img {
      width: 73px;
      height: 70px;
      display: block;
      margin: auto;
      margin-bottom: 12px;
    }
    .hint {
      font-size: 8px;
      font-weight: 500;
      color: #000000;
      line-height: 11px;
    }
    > button {
      margin-top: 9px;
      border: none;
      width: 109px;
      height: 23px;
      background: linear-gradient(135deg, #ff7f7c, #ff5752);
      border-radius: 11px;
      color: #ffffff;
      font-size: 10px;
    }
    &.scene {
      .desc {
        font-size: 12px;
        font-weight: normal;
        margin: 0 0 4px;
      }
      .title {
        margin-bottom: 12px;
      }
      > img {
        display: block;
        margin: auto;
      }
      .card {
        display: flex;
        justify-content: space-around;
        .sceneItem, .redPacketItem {
          > div {
            width: 97px;
            height: 118px;
            padding-top: 60px;
            > p {
              font-size: 9px;
              line-height: 11px;
              padding: 0 10px;
              text-align: justify;
              color: #7B7B7B;
              > span {
                color: #FF5955;
              }
            }
          }
          > button {
            width: 86px;
            height: 20px;
            border: none;
            background-color: #FF5955;
            color: #FFFFFF;
            font-size: 8px;
            border-radius: 2px;
          }
        }
        .sceneItem {
          > div {
            background: url('#{$cdn-url}/kuaishou/complete1.png') no-repeat;
            background-size: 100% 100%;
          }
        }
        .redPacketItem {
          > div {
            background: url('#{$cdn-url}/kuaishou/complete2.png') no-repeat;
            background-size: 100% 100%;
          }
        }
      }
      .hint {
        color: #7B7B7B;
        margin-top: 2px;
      }
    }
  }
}

.actFinish {
  text-align: center;
  padding-top: 100px;
  > img {
    display: inline-block;
    width: 136px;
    height: 94px;
    margin-left: -20px;
    margin-bottom: 10px;
  }
  > p {
    color: #707070;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 2px;
  }
  .hint {
    font-size: 11px;
    font-weight: bold;
    color: #878787;
  }
}
</style>
